import { DevicePlatformFromJSON, DevicePlatformToJSON, } from './DevicePlatform';
/**
 * Check if a given object implements the UserActivity interface.
 */
export function instanceOfUserActivity(value) {
    let isInstance = true;
    isInstance = isInstance && "appVersion" in value;
    isInstance = isInstance && "devicePlatform" in value;
    isInstance = isInstance && "timestamp" in value;
    return isInstance;
}
export function UserActivityFromJSON(json) {
    return UserActivityFromJSONTyped(json, false);
}
export function UserActivityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'appVersion': json['appVersion'],
        'devicePlatform': DevicePlatformFromJSON(json['devicePlatform']),
        'timestamp': (new Date(json['timestamp'])),
    };
}
export function UserActivityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'appVersion': value.appVersion,
        'devicePlatform': DevicePlatformToJSON(value.devicePlatform),
        'timestamp': (value.timestamp.toISOString()),
    };
}
